(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
(() => {
  function setup(root) {
    const form = root.querySelector('form');
    if (!form || form.dataset.iucReady) return;
    form.dataset.iucReady = 'true';
    const inputs = [...form.querySelectorAll('[data-quantity-input]')];
    function syncNames() {
      const mobile = matchMedia('(max-width: 749px)').matches;
      inputs.forEach(input => {
        if (input.hasAttribute(mobile ? 'data-quantity-input-mobile' : 'data-quantity-input-desktop')) input.name = 'updates[]';
        else input.removeAttribute('name');
      });
    }
    syncNames();
    matchMedia('(max-width: 749px)').addEventListener('change', syncNames);
    form.addEventListener('change', event => {
      const input = event.target.closest('[data-quantity-input]');
      if (!input || !input.checkValidity()) return;
      const quantity = Number(input.value);
      if (!Number.isInteger(quantity) || quantity < 0) return;
      inputs.filter(other => other.dataset.quantityItem === input.dataset.quantityItem).forEach(other => {other.value = quantity;});
      const update = form.querySelector('[name="update"]');
      if (update) form.requestSubmit(update);
    });
  }
  const init = () => document.querySelectorAll('[data-section-type="iuc-cart"]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iuc-complementary"] && !Shopify.designMode) return;
  try {
    
(() => {
  const load = root => root.querySelectorAll('[data-iuc-complementary]').forEach(el => {
    if (el.dataset.iucLoaded || el.children.length) return;
    el.dataset.iucLoaded = 'true';
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      observer.disconnect();
      fetch(el.dataset.url).then(r => { if (!r.ok) throw new Error('Recommendations unavailable'); return r.text(); }).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-iuc-complementary]');
        if (content && content.children.length) el.replaceChildren(...content.children);
      }).catch(() => {});
    }, { rootMargin: '300px' });
    observer.observe(el);
  });
  load(document);
  document.addEventListener('shopify:section:load', e => load(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ius-collection"]) return;
  try {
    
document.addEventListener('submit', function (event) {
  const form = event.target;
  const group = form.querySelector('[data-product-group]');
  if (group) form.action = group.value;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ius-header"] && !Shopify.designMode) return;
  try {
    
(() => {
 const update = () => document.documentElement.classList.toggle('ius-scrolled', window.scrollY > 35);
 update(); window.addEventListener('scroll', update, { passive: true });
 document.addEventListener('toggle', e => { if (e.target.matches('.ius-menu')) { e.target.querySelector('summary').setAttribute('aria-label', e.target.open ? e.target.dataset.closeLabel : e.target.dataset.openLabel); } }, true);
 document.addEventListener('click', e => document.querySelectorAll('[data-ius-disclosure][open]').forEach(d => { if (!d.contains(e.target)) d.open = false; }));
 document.addEventListener('keydown', e => { if (e.key === 'Escape') document.querySelectorAll('[data-ius-disclosure][open]').forEach(d => { d.open = false; d.querySelector('summary').focus(); }); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ius-panels"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ius-video-id]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const id = link.dataset.iusVideoId;
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    event.preventDefault();
    const frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0&autoplay=1';
    frame.title = link.dataset.iusVideoTitle || link.getAttribute('aria-label');
    frame.width = '960';
    frame.height = '540';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.allowFullscreen = true;
    link.replaceWith(frame);
    frame.focus();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
